(function () {
  const states = new WeakMap();
  function state(bar) {
    if (!states.has(bar)) states.set(bar, { sequence: 0, timer: null, controller: null, index: -1 });
    return states.get(bar);
  }
  function collapse(bar) {
    bar.inputElement.setAttribute('aria-expanded', 'false');
    bar.inputElement.removeAttribute('aria-activedescendant');
    bar.searchResultsElement.setAttribute('aria-hidden', 'true');
  }
  function dismiss(bar) {
    const s = state(bar);
    s.sequence++;
    clearTimeout(s.timer);
    s.controller?.abort();
    s.index = -1;
    bar.searchBarElement.classList.remove('is-loading');
    collapse(bar);
  }
  function search(bar) {
    dismiss(bar);
    const query = bar.inputElement.value.trim();
    bar.searchBarElement.querySelector('.search-bar__results-inner').replaceChildren();
    if (!query) return;
    const s = state(bar), sequence = s.sequence;
    s.timer = setTimeout(async () => {
      const controller = new AbortController();
      s.controller = controller;
      const deadline = setTimeout(() => controller.abort(), 8000);
      bar.searchBarElement.classList.add('is-loading');
      if (bar.searchMenuElement) bar.searchMenuElement.setAttribute('aria-hidden', 'true');
      const params = new URLSearchParams({ q: query, section_id: 'search-ajax', 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][unavailable_products]': window.theme.searchUnavailableProducts || 'last' });
      try {
        const response = await fetch(`${window.routes.searchUrl}/suggest?${params}`, { credentials: 'same-origin', signal: controller.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Suggestions unavailable');
        const text = await response.text();
        if (sequence !== s.sequence || query !== bar.inputElement.value.trim()) return;
        const fragment = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-wholesale-predictions]');
        if (!fragment) throw new Error('Suggestions unavailable');
        const target = bar.searchBarElement.querySelector('.search-bar__results-inner');
        target.replaceChildren(...fragment.childNodes);
        target.querySelectorAll('[role="option"]').forEach((option, i) => { option.id = `wholesale-search-option-${i}`; });
        bar.searchResultsElement.setAttribute('aria-hidden', 'false');
        bar.inputElement.setAttribute('aria-expanded', 'true');
        bar.searchBarElement.classList.add('is-expanded');
        const status = bar.searchResultsElement.querySelector('[data-search-status]');
        if (status) status.textContent = fragment.dataset.status || '';
      } catch (error) {
        if (sequence !== s.sequence) return;
        collapse(bar);
      } finally {
        clearTimeout(deadline);
        if (sequence === s.sequence) bar.searchBarElement.classList.remove('is-loading');
      }
    }, 250);
  }
  function keydown(bar, event) {
    if (event.isComposing) return;
    if (event.key === 'Escape') { bar._unfixMobileSearch(); return; }
    if (bar.inputElement.getAttribute('aria-expanded') !== 'true') return;
    const options = [...bar.searchResultsElement.querySelectorAll('[role="option"]')];
    const s = state(bar);
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (!options.length) return;
      event.preventDefault();
      s.index = s.index < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (s.index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options.forEach((option, i) => option.setAttribute('aria-selected', String(i === s.index)));
      bar.inputElement.setAttribute('aria-activedescendant', options[s.index].id);
      options[s.index].scrollIntoView({ block: 'nearest' });
    } else if (event.key === 'Enter' && s.index >= 0 && options[s.index]) {
      event.preventDefault();
      options[s.index].click();
    } else if (event.key === 'Tab') {
      dismiss(bar);
    }
  }
  window.WholesalePredictiveSearch = { search, keydown, dismiss };
})();
